import { createFileRoute } from "@tanstack/react-router";

import { PatientMedicalFilePage } from "@/uiKit/pages/PatientMedicalFilePage.tsx";

export const Route = createFileRoute("/_practitioner/patients/$patientId/medical-file")({
  component: PatientMedicalFilePage,
});
